<template>
    <judicial-recovery-enterprise-page
        nature="Recuperação extrajudicial"
        back-to="/recuperacao-extrajudicial"
    />
</template>
<script>
import JudicialRecoveryEnterprisePage from './JudicialRecoveryEnterprisePage.vue';
export default {
    name: 'ExtrajudicialRecoveryEnterprisePage',
    components: { JudicialRecoveryEnterprisePage }
};
</script>
